import Typography from 'material-ui/Typography'
import React from 'react'
const CLINTAL_BLUE = '#5A8DDA'

import withStyles from 'material-ui/styles/withStyles'
import styleSheet from './AllWebChatStyle.style'

class WebChatUserPlan extends React.Component {
  render() {
    const { plan_name, plan_price, plan_start_date, plan_end_date, staff_chat_count, chat_limit, flag_trial_plan } =
      this.props
    const classes = this.props.classes
    return (
      <div className={classes.userPlan}>
        <div className={classes.userPlan_ribbon}>加入中</div>
        <div className={classes.userPlan_firstDiv}>
          <Typography className={classes.userPlan_name}>{plan_name}</Typography>
          <Typography className={classes.userPlan_price}>{plan_price}</Typography>
        </div>

        <div className={classes.userPlan_secondDiv}>
          {flag_trial_plan ? null : (
            <div>
              <Typography className={classes.userPlan_date}>プランの有効期限</Typography>
              <Typography className={classes.userPlan_chatCount}>
                <b>
                  {plan_start_date} 〜 {plan_end_date}
                </b>
              </Typography>
            </div>
          )}
          <div className={classes.userPlan_content}>
            <Typography className={classes.userPlan_date}>健康相談チャット利用可能回数</Typography>
            <Typography className={classes.userPlan_chatCount}>
              <b>
                今月は残り{staff_chat_count}回/{chat_limit}
              </b>
            </Typography>
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styleSheet)(WebChatUserPlan)
